import AdminCrudPage from "../Commaon/AdminCrudPage";
import { getMenuOptions } from "../../utils/menuAccess";

const RolesList = () => {
  const menuOptions = getMenuOptions();

  return (
    <AdminCrudPage
      title="Roles"
      listPath="/admin/role"
      addPath="/admin/role"
      editPath={(id) => `/admin/role/${id}`}
      deletePath={(id) => `/admin/role/${id}`}
      getByIdPath={(id) => `/admin/role/${id}`}
      statusPath={(id) => `/admin/role/${id}`}
      addButtonLabel="Add Role"
      fields={[
        { name: "name", label: "Name" },
        { name: "description", label: "Description", type: "textarea" },
        {
          name: "menus",
          label: "Menus",
          type: "modal-multiselect",
          options: menuOptions,
        },
      ]}
      columns={[
        { key: "name", label: "Name" },
        { key: "description", label: "Description" },
        {
          key: "menus",
          label: "Menus",
          render: (value) => (Array.isArray(value) ? value.length : "-"),
        },
        {
          key: "isActive",
          label: "Status",
          render: (value) => (
            <span className={`badge ${value ? "bg-success" : "bg-secondary"}`}>
              {value ? "Active" : "Inactive"}
            </span>
          ),
        },
      ]}
      searchFields={["name", "description"]}
      compactTable
    />
  );
};

export default RolesList;
